import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import HomePage from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ListLandPages from './pages/ListLand';
import Layout from './pages/Layout';
import ForgotPassword from './pages/ForgotPassword';
import AddLandForm from './pages/RegisterLand';
import PageNotFound from './pages/PageNotFound';
import MyProfile from './pages/MyProfile';
import MyWallet from './pages/MyWallet';
import MyListings from './pages/MyListings';
import SellerPlan from './pages/SellerPlan';
import BuyerPlan from './pages/BuyerPlan';
import LandDetails from './pages/LandDetails';
import UpdateLand from './pages/UpdateLand';
import AboutPage from './pages/About';
import FAQPage from './pages/BasicFaq';
import AdvancedFAQ from './pages/AdvanceFaqs';


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Layout />} />
          <Route index element={<ListLandPages />} />
          {/* <Route path='/' element={<HomePage />} /> */}
          {/* <Route path='/:landType/:state/:district' element={<ListLandPages />} /> */}
          <Route path='/:state/:district' element={<ListLandPages />} />
          <Route path='/:state' element={<ListLandPages />} />
          <Route path='/landlist' element={<ListLandPages />} />
          <Route path='/login'  element={<Login />} />
          <Route path='/signup'  element={<Signup />} />
          <Route path='/forgot-password' element = {<ForgotPassword/>}/>
          <Route path='/register-land' element = {<AddLandForm/>}/>
          <Route path='/profile' element = {<MyProfile/>}/>
          <Route path='/wallet' element={<MyWallet/>}/>
          <Route path= '/listings' element={<MyListings/>}/>
          <Route path= '/home' element={<HomePage/>}/>
          <Route path= '/seller-plans' element={<SellerPlan/>}/>
          <Route path= '/buyer-plans' element={<BuyerPlan/>}/>
          <Route path= '/land-details/:landId' element={<LandDetails/>}/>
          <Route path= '/update-land/' element={<UpdateLand/>}/>
          <Route path='/about' element={<AboutPage/>}/>
          <Route path='/faqs' element={<FAQPage/>}/>
          <Route path='/advanced-faqs' element={<AdvancedFAQ/>}/>
          <Route path='*' element ={<PageNotFound/>}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
